import "./PinFlow.scss";
import { IonContent, IonIcon, IonImg, IonModal, IonButton } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useTracked } from "../../state";
import { isPlatform } from "@ionic/core";
import { identityService } from "../../services/vault";
import { AuthMode } from "@ionic-enterprise/identity-vault";
import abaxxLogo from "../../assets/svg/logoAbaxx.svg";
import phoneLockImage from "../../assets/svg/phone-lock.svg";

interface Props {
  user: any;
  token: any;
}

const PinFlow: React.FC<Props> = React.memo(({ user, token }) => {
  const [, dispatch] = useTracked();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (token && user) {
      if (!user.isFirstTimeLogin) {
        tryInitPinFlow();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, token]);

  const tryInitPinFlow = async () => {
    try {
      
      if (isPlatform("cordova")) {
        const authMode = await identityService.getAuthMode();
        if (authMode === AuthMode.SecureStorage && localStorage.getItem("isFromRecoverFlow") === "true") {
          localStorage.setItem("isFromRecoverFlow", JSON.stringify(false));
          setIsOpen(true);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleEnablePIN = () => {
    localStorage.setItem("isOnlyPin", JSON.stringify(true));
    localStorage.setItem("isPersonalizePIN", "y");
    dispatch({ type: "showApplicationsPIN", setApplicationsPin: true });
    setIsOpen(false);
  };

  return (
    <IonModal
      isOpen={isOpen}
      className="pin-flow-modal"
      backdropDismiss={false}
    >
      <IonContent>
        <div className="pin-flow-modal-container">
          <div className="pin-flow-modal-content">
            <div className="content-container">
              <IonIcon icon={abaxxLogo} className="app-logo" />
              <p className="subtitle">Pin Lock</p>

              <div className="pin-lock-container">
                <IonImg src={phoneLockImage} />

                <p>
                  Enable PIN from your device to unlock the
                  application and confirm when switching between accounts
                </p>

                <IonButton
                  color="danger"
                  expand="full"
                  shape="round"
                  onClick={handleEnablePIN}
                >
                  Enable PIN
                </IonButton>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
});

const MemoizedPinFlow = () => {
  const [state] = useTracked();
  const { user, token } = state;
  return <PinFlow user={user} token={token} />;
};

export default MemoizedPinFlow;
